import { get } from "../index";
import UploadOss from "./uploadFile";
import UploadS3 from "./uploadFileS3";
import UploadAws from "./uploadFileAws";
import UploadHuawei from "./uploadFileHuawei";

const uploadDict = function (param) {
  const uploadType = get(param, "uploadType", "oss");
  const dict = {
    oss: UploadOss,
    s3: UploadS3,
    aws: UploadAws,
    huawei: UploadHuawei,
  };
  return dict[uploadType];
};

const uploadFileControl = async function (param) {
  const uploadType = get(param, "uploadType", null);

  if (uploadType == null) {
    return;
  }
  const Upload = uploadDict(param);
  const uploadFileObj = new Upload(param);
  await uploadFileObj.getSign();
  return uploadFileObj;
};

export default uploadFileControl;



// WEBPACK FOOTER //
// ./src/yx-widget/utils/upload/index.js